import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updateHighTax = (matchId, highTax, token) => async dispatch => {
    dispatch({
        type: actionTypes.UPDATE_HIGH_TAX_START
    });
    const options = {
        url: `${api}/matches/${matchId}/updateHighTax`,
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        data: {
            highTax
        }
    }
    await axios(options)
        .then(response => {
            dispatch({
            type: actionTypes.UPDATE_HIGH_TAX_SUCCESS,
            payload: response.data
        })})
        .catch(error => dispatch({
            type: actionTypes.UPDATE_HIGH_TAX_FAIL,
            payload: getMessage(error)
        }))
}